module.exports = __webpack_public_path__ + "img/person_5.635fc95f.jpg";